import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="hp-fade-up w-full px-4 md:px-6 pt-32 pb-24">
      <div className="max-w-lg mx-auto text-center">
        <div className="font-label font-black text-7xl md:text-8xl text-background-200 select-none mb-2">
          404
        </div>
        <h1 className="font-heading font-black text-2xl md:text-3xl text-foreground-950 mb-3">
          这个页面走丢了
        </h1>
        <p className="text-sm text-foreground-500 mb-2">
          没有找到对应内容，可能是链接有误或页面已被移除。
        </p>
        <p className="text-xs text-foreground-400 font-mono mb-8 break-all">{location.pathname}</p>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 text-sm font-medium px-5 py-2.5 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/category/works"
            className="inline-flex items-center gap-2 border border-foreground-300 text-foreground-800 text-sm font-medium px-5 py-2.5 rounded-md hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-film-line" />
            浏览作品库
          </Link>
        </div>
      </div>
    </div>
  );
}